module.exports = __webpack_public_path__ + "media/images/flags/4x3/eri-31a061905846a168e877407691a99f6d.svg";